import { Model } from "pinia-orm";
import Domain from "./Domain.js";

export default class Mission extends Model {
  static entity = "missions";
  static primaryKey = "uuid";

  static fields() {
    return {
      uuid: this.uid(""),
      description: this.string(""),
      code: this.string(""),
      internalCode: this.string(""),
      shortLabel: this.string(""),
      longLabel: this.string(""),
      createdAt: this.string(""),
      updatedAt: this.string(""),

      domainUuid: this.string(""),
      domain: this.belongsTo(Domain, "domainUuid"),
    };
  }
  get codeShortLabel() {
    return `${this.code} - ${this.shortLabel}`;
  }
  static with = ["domain", "domain.activityNature"];
}
